import { memo, useCallback } from "react";
import type { Group } from "contexts/GroupsContext/GroupsContext";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";
import useBoolean from "hooks/useBoolean";
import TrashIcon from "components/Icons/TrashIcon";
import DeleteGroupDialog from "features/Groups/DeleteGroupDialog";
import { useGroupActions } from "providers/GroupsProvider";

interface DeleteGroupActionProps {
  group: Group;
}

function DeleteGroupAction(props: DeleteGroupActionProps) {
  const { group } = props;
  const { t } = useTranslation();
  const { value: open, toggle } = useBoolean();
  const groupActions = useGroupActions();

  const handleDelete = useCallback(() => {
    groupActions.delete(group.id);
  }, [groupActions, group.id]);

  return (
    <>
      <IconButton
        aria-label={t("group.delete_group_name_aria_label", { name: group.name })}
        color="primary"
        onClick={toggle}
      >
        <TrashIcon fontSize="small" />
      </IconButton>
      <DeleteGroupDialog open={open} onClose={toggle} group={group} onConfirm={handleDelete} />
    </>
  );
}

export default memo(DeleteGroupAction);
